/* eslint no-unused-vars:0 */
/* eslint react/prop-types:0 */
import React from 'react'
import './FileInput.css'

export const field_file = ({ input, type, meta: { touched, error, warning } }) => {
    delete input.value
    return (
        <div>  
            <input {...input} type={type}  style={{ display:'none',marginTop:'20px' }} />
        </div>
    )
  
  }

  


// WEBPACK FOOTER //
// ./src/utils/constants/FileInput.js